/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/machine.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle.geometry}
        material={materials.Ring}
        position={[0, 1.57, 0]}
      />
      <mesh castShadow receiveShadow geometry={nodes.Body.geometry} material={nodes.Body.material} />
    </group>
  )
}

useGLTF.preload('/machine.glb')
